<template>
  <div>
    <v-card style="margin-bottom: 20px;">
      <v-toolbar color="primary" :dark="protocol.dark">
        <v-toolbar-side-icon>
          <v-icon>mdi-shield-check</v-icon>
        </v-toolbar-side-icon>
        <v-toolbar-title>{{ value.company }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="deleteInsurance">
          <v-icon>mdi-delete-forever</v-icon>
        </v-btn>
      </v-toolbar>
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-text-field box label="Forsikringsselskap" hint="Navn på forsikringsselskapet for denne forsikringen" v-model="value.company" class="mr-sm-2"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field box label="Forsikringstaker" hint="Navn på personen som er satt opp som forsikringstaker for denne forsikringen" v-model="value.taker" class="ml-sm-2"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field box label="Dato" v-model="value.date" hint="Dato for opprettelse av denne forsikringen" class="mr-sm-2"></v-text-field>
          </v-flex>
          <v-flex xs12 sm6>
            <v-text-field box label="Forsikret/begunstiget person" hint="Hvilken person er forsikret" v-model="value.person" class="ml-sm-2"></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </div>
</template>

<script>
export default {
  props: ["value", "protocol", "index"],
  methods: {
    deleteInsurance() {
      this.$emit("delete-insurance", this.index);
    }
  }
};
</script>